import { createContext, useContext, type PropsWithChildren, type ReactElement } from 'react';
import {
  useIssueChartResultsInternal,
  type IssueChartRuntime,
} from './useIssueChartResultsInternal';

const IssueChartRuntimeContext = createContext<IssueChartRuntime | null>(null);

export function IssueChartRuntimeProvider({
  children,
}: PropsWithChildren<{}>): ReactElement {
  const runtime = useIssueChartResultsInternal();

  return (
    <IssueChartRuntimeContext.Provider value={runtime}>
      {children}
    </IssueChartRuntimeContext.Provider>
  );
}

export function useIssueChartRuntime(): IssueChartRuntime {
  const runtime = useContext(IssueChartRuntimeContext);
  if (!runtime) {
    throw new Error(
      'useIssueChartRuntime requires IssueChartRuntimeProvider'
    );
  }
  return runtime;
}

export function useIssueChartRuntimeOptional(): IssueChartRuntime | null {
  return useContext(IssueChartRuntimeContext);
}
